import { render, staticRenderFns } from "./BetaIcon.vue?vue&type=template&id=555a8812&"
import script from "./BetaIcon.vue?vue&type=script&lang=js&"
export * from "./BetaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555a8812')) {
      api.createRecord('555a8812', component.options)
    } else {
      api.reload('555a8812', component.options)
    }
    module.hot.accept("./BetaIcon.vue?vue&type=template&id=555a8812&", function () {
      api.rerender('555a8812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/BetaIcon.vue"
export default component.exports